module.exports = __webpack_public_path__ + "assets/img/19_861.be5404e4.jpg";